import 'react-dropzone-uploader/dist/styles.css';
import * as discoverInterfaces from '../../../Interfaces/discover.interfaces';
import {SimpleTextInput} from '../../Atoms/Fields';
import {makeStyles} from '@material-ui/core/styles';
import DropzoneWrapper from './DropzoneWrapper';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import List from '@material-ui/core/List';
import React, {useEffect} from 'react';
import SimpleListItem from '../../Atoms/SimpleListItem';
import Typography from '@material-ui/core/Typography';
import _ from 'lodash';

import useDebounce from '../../../Hooks/useDebounce';


const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        // flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    panelDetails: {
        flexDirection: 'column',
        alignItems: 'center',
    },
    uploadedList: {
        marginBottom: theme.spacing(2),
    },
}));
const DiscoverCardTypeLinkAds = (props: discoverInterfaces.IFieldTypeAd) => {
    const {hook} = props;
    const classes = useStyles();
    // // const imageURL = props.activeDiscover.content.imageURL;
    const [expanded, setExpanded] = React.useState<boolean | string>('panel1');
    useEffect(() => {
        if (Object.keys(hook.errors).length > 0) {
            setExpanded('all');
        }
    }, [hook.errors]);
    const handleChange = (panel: 'panel1' | 'panel2' | 'panel3' | 'panel4') => (event: any, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <React.Fragment>
            <div className={classes.root}>
                <ExpansionPanel
                    expanded={expanded === 'panel4' || expanded === 'all'}
                    onChange={handleChange('panel4')}
                >
                    <ExpansionPanelSummary
                        aria-controls="panel4bh-content"
                        expandIcon={<ExpandMoreIcon/>}
                        id="panel4bh-header"
                    >
                        <Typography className={classes.heading}>Ads</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails classes={{root: classes.panelDetails}}>
                        <Typography component="p" gutterBottom variant="body2">
                            <em>
                                {' '}
                                Changes will automatically be saved when removing an uploaded document or adding a new
                                one. No need to click "update".{' '}
                            </em>
                        </Typography>
                        <AdsManager {...props} />
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            </div>
            {/* <DocumentsUpload {...props} /> */}
        </React.Fragment>
    );
};

const AdsManager = (props: any) => {
    const classes = useStyles();
    const {activeDiscover, handleSubmit, hook, removeAd} = props;
    //Let's listen to the hook and auto submit when the values of toUpload have changed!
    const toUpload = _.get(hook, 'values.ads.toUpload');
    const debouncedToUpload = useDebounce(toUpload, 1000);

    useEffect(() => {
        if (toUpload && toUpload.length > 0) handleSubmit(); //Trigger form submission
    }, [debouncedToUpload]);
    // called every time a file's `status` changes
    const handleChangeStatus = (file: any, status: any, files: any) => {
        //Let's update values in the hook when the a file is removed from the dropzone
        if (status === 'removed') {
            const nextCollection = hook.values.ads.toUpload.filter((obj: any) => obj.name !== file.meta.name);
            hook.handleChange({
                target: {
                    name: 'ads',
                    value: {
                        ...hook.values.ads,
                        toUpload: nextCollection,
                    },
                },
            });
        }
        //Let's update values in the hook when the dropzone is finished preparing the files
        if (status === 'done') {
            const preppedFiles = files.map((obj: any) => {
                return obj.file;
            });
            hook.handleChange({
                target: {
                    name: 'ads',
                    value: {...hook.values.ads, toUpload: preppedFiles},
                },
            });
        }
    };
    const uploaded = _.get(activeDiscover, 'content.ads.uploaded');
    return (
        <React.Fragment>
            <hr/>
            <Typography component="h4" gutterBottom variant="subtitle1">
                <strong> Uploaded ads</strong>
            </Typography>
            {!uploaded && (
                <Typography component="p" gutterBottom paragraph variant="body1">
                    <em> No ads have been uploaded for this card</em>
                </Typography>
            )}
            {uploaded && (
                <List classes={{root: classes.uploadedList}}>
                    {uploaded.map((obj: any, idx: number) => {
                        const adId = obj.id;
                        const urlVal =  _.get(hook, ['values', 'adUrls', adId ]) ?  _.get(hook, ['values', 'adUrls', adId ]) : obj.adUrl;
                        return (
                            <>
                                <SimpleListItem
                                    avatarIcon="cloud_done"
                                    avatarType="icon"
                                    handleRemove={(evt: any) => {
                                        removeAd(obj);
                                    }}
                                    id={obj.id}
                                    key={idx}
                                    primaryText={obj.name}
                                />
                                {/*<Grid alignItems={'center'} container direction="row" justify="center" spacing={3}>*/}
                                {/*    <Grid>*/}
                                        <SimpleTextInput
                                            hook={hook}
                                            value={urlVal}
                                            handleChange={(evt:any)=>props.handleAdUrlChange(evt.target.value, obj.id)}
                                            label="Url"
                                            name={'ad_url[' + obj.id+']'} type="url"/>
                                {/*    </Grid>*/}

                                {/*</Grid>*/}
                            </>
                        );
                    })}
                </List>
            )}
            <Typography component="h4" gutterBottom paragraph variant="subtitle1">
                <strong> Add additional ads</strong>
            </Typography>
            <DropzoneWrapper
                accept={'image/*'}
                labels={[
                    {
                        type: 'jpg, png, gif',
                        additional: {
                            file: ' < 5mb',
                        },
                        icon: 'picture_as_pdf',
                    },
                ]}
                maxSizeBytes={5000000}
                multiple={true}
                name="ads"
                {...props}
                handleChangeStatus={handleChangeStatus}
            />
        </React.Fragment>
    );
};

export default DiscoverCardTypeLinkAds;
